/*! @azure/msal-common v16.7.0 2026-06-05 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.7.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
